import React from 'react';
import { Link } from 'react-router-dom';

const linkClass =
  'rounded-sm text-dusk-300 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white';

const PublicFooter: React.FC = () => {
  return (
    <footer className="bg-dusk-950 font-road text-sm text-dusk-300">
      <div className="mx-auto flex max-w-6xl flex-col gap-8 px-4 py-12 sm:px-6 md:flex-row md:items-center md:justify-between">
        <div>
          <Link
            to="/"
            className="inline-block rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-4 focus-visible:ring-offset-dusk-950"
          >
            <span className="inline-block -skew-x-6 bg-livery-600 px-2.5 py-1 font-signage text-[1.35rem] font-extrabold italic uppercase leading-none tracking-wide text-white">
              Cruiser
            </span>
          </Link>
          <p className="mt-4 max-w-xs leading-relaxed text-dusk-300">
            Shuttle seats and parcel delivery, booked and tracked online.
          </p>
        </div>

        <nav className="flex flex-wrap gap-x-8 gap-y-3 text-[15px]">
          <Link to="/trips" className={linkClass}>Book a Trip</Link>
          <Link to="/track" className={linkClass}>Track Parcel</Link>
          <Link to="/login" className={linkClass}>Sign in</Link>
        </nav>
      </div>
      <div className="border-t border-white/10">
        <p className="mx-auto max-w-6xl px-4 py-6 text-dusk-400 sm:px-6">
          © {new Date().getFullYear()} Cruiser. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default PublicFooter;
